import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {Helmet} from "react-helmet";
import {
  HeroBlock,
  GelContentContainer,
  GelContentRow,
  GelContentColumn,
  ApiPager,
  CheckboxElement,
  Link,Controls,ButtonSecondary,
  withFlashState,  withAuthentication,  Notices,
  withVenuesApi, FormErrorSummary
} from "cw-styleguide-react";
import {route} from "../../../../routes";
import VenusManageTranslateFilterForm from "../../components/translate/VenuesManageTranslateFilterForm";

import withAssets from "../../../../components/hoc/withAssets";


class VenuesTranslateManageView extends Component {

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.venues.translateManage.title')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.t('local:view.venues.translateManage.title')}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>{this.props.t('local:view.venues.translateManage.introduction')}</p>
        </HeroBlock>



        <GelContentContainer>

          <Notices messages={this.props.messages} />
          <FormErrorSummary errors={this.props.formErrors}/>

          {/* Display the page control buttons */}
          <Controls>
            <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkAssign'], true)}} title={this.props.t('local:view.venues.translateManage.controls.assignToMe')}>{this.props.t('local:view.venues.translateManage.controls.assignToMe')}</ButtonSecondary>
            { (this.props.authentication.hasRole('Courses_TranslatorManager') ) && <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkUnassign'], true)}} title={this.props.t('local:view.venues.translateManage.controls.reassign')}>{this.props.t('local:view.venues.translateManage.controls.reassign')}</ButtonSecondary>}
          </Controls>


          <h2>{this.props.t('local:view.venues.translateManage.formHeader.title')}</h2>
          <p>{this.props.t('local:view.venues.translateManage.formHeader.introduction')}</p>


          <GelContentRow>
            <GelContentColumn xs={12} sm={12} md={4} lg={4} mdPush={8} lgPush={8}>
              <VenusManageTranslateFilterForm filterValues={this.props.filterValues} translators={this.props.translators} filteredTranslators={this.props.filteredTranslators}  handleChange={this.props.handleChange} handleReset={this.props.handleReset} handleSubmit={this.props.handleSubmit}/>
            </GelContentColumn>

            <GelContentColumn xs={12} sm={12} md={8} lg={8} mdPull={4} lgPull={4}>
              <ApiPager api={this.props.venuesApiGetEndpoint('venues_api_venues_q')}
                        filters={{
                          statuses: this.props.filterValues.status ? [this.props.filterValues.status] : ['267040002','267040005'],
                          venueName: this.props.filterValues.venueName,
                          postCode: this.props.filterValues.postCode,
                          townCity: this.props.filterValues.townCity,
                          translatorAssigned: this.props.filterValues.translatorAssigned,
                        }}
                        sortOptions={[
                          {
                            value: 'rel',
                            label: this.props.t('styleguide:forms.order.options.rel')
                          },
                          {
                            value: 'asc',
                            label: this.props.t('styleguide:forms.order.options.asc')
                          },
                          {
                            value: 'desc',
                            label: this.props.t('styleguide:forms.order.options.desc')
                          }
                        ]}
                        handleStateChange={this.props.handleStateChange}
                        initialOrder={this.props.filterValues['order']}
                        initialPage={this.props.filterValues['page']}
                        initialGroupSize={this.props.filterValues['groupSize']}
                        autoReload={false}
                        reloadKey={this.props.reloadKey}
                        onReloadResetPage={true}
                        noResultsText={this.props.t('styleguide:messages.noResults')}
                        hasResultsText={''}
                        table={true}
                        tableHeader={() => (
                          <tr>
                            <th>{this.props.t('local:view.venues.manage.tableHeader.select')}</th>
                            <th>{this.props.t('local:view.venues.manage.tableHeader.name')}</th>
                            <th>{this.props.t('local:view.venues.manage.tableHeader.postcode')}</th>
                            <th>{this.props.t('local:view.venues.manage.tableHeader.townCity')}</th>
                            <th>{this.props.t('local:view.venues.manage.tableHeader.status')}</th>
                          </tr>
                        )}
                        render={(venue) => (<tr>


                          <td><CheckboxElement onChange={this.props.handleBulkCheckbox} checked={this.props.selected.has(venue.venueId) } value={venue.venueId}/></td>
                          <td>  <Link to={route("venuesTranslateManage") + route(venue.status === '267040002' ? 'venuesTranslateDraft' : 'venuesTranslateAmended',{"venue" : venue.venueId})}>{venue.venueName}</Link></td>
                          <td> {venue.postCode}</td>
                          <td>{venue.townCity}</td>
                          <td>{this.props.courses.getStatusName(venue.status)}</td>


                        </tr>)}/>
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>

    )
  }

}

export default withVenuesApi(process.env)(withAuthentication( withAssets(withFlashState(withTranslation('local')(VenuesTranslateManageView)))));
